import type { SiteThemeConfig } from '@/shared/providers/theme/types';
import { KEILOG_BRAND } from '../../../constants/brand';
import { keilogConfig } from '../tenantConfig';

/**
 * Keilog clinic-portal theme.
 *
 * This themes the classic RA2N console (login, and any screen not inside the
 * RAH shell). Inside the shell the look comes from `styles/rah-shell.scss` and
 * the antd themes in `theme/antdTheme.ts`, not from here.
 */
/** A2 (鍼灸): brand blue. */
const a2Colors = {
  primary: KEILOG_BRAND.brand,
  primaryHover: KEILOG_BRAND.brandHover,
  primaryActive: KEILOG_BRAND.brandDeep,
  primaryLight: KEILOG_BRAND.brandLight,
  primaryDark: KEILOG_BRAND.brandDeep,

  secondary: KEILOG_BRAND.accent,
  secondaryHover: KEILOG_BRAND.accentBright,
  secondaryActive: KEILOG_BRAND.accentDeep,

  text: KEILOG_BRAND.inkBody,
  textLight: KEILOG_BRAND.inkLabel,

  background: KEILOG_BRAND.canvas,
  surface: KEILOG_BRAND.surface,

  border: KEILOG_BRAND.border,

  // BC-60: the RAH sidebar is a light surface, not a dark rail.
  sidebarBg: KEILOG_BRAND.canvas,
  sidebarBgInactive: KEILOG_BRAND.brandPale,
  sidebarText: KEILOG_BRAND.inkBody,
  sidebarActive: KEILOG_BRAND.brand,

  menuOpen: 'rgba(0, 84, 172, 0.04)',
  menuHover: 'rgba(0, 84, 172, 0.08)',
  menuActive: 'rgba(0, 84, 172, 0.14)',

  headerBg: KEILOG_BRAND.surface,
  headerText: KEILOG_BRAND.inkBody,

  sectionHeader: KEILOG_BRAND.brand,
  sectionHeaderText: KEILOG_BRAND.surface,

  tableHeader: KEILOG_BRAND.brandPale,
  tableRowHover: KEILOG_BRAND.brandLight,
};

/**
 * R2 (マッサージ): the same brand blue as A2. KEiLOG has one primary colour whatever the
 * service (BC `--brand`: button primary, link, focus; the login concept draws #0054AC too).
 * Pink #EE66A2 is the logo accent, never a primary or a button fill (BC-12, BC-13), and the
 * login page reads whichever service the browser used last, so a pink R2 primary leaked
 * onto ログイン.
 */
const r2Colors = { ...a2Colors };

export const keilogTheme: SiteThemeConfig = {
  siteType: 'keilog',
  siteName: keilogConfig.name,

  A2: {
    name: 'keilog-a2',
    displayName: 'KEiLOG A2',
    logoPath: '/images/keilog/keilog_text.png',
    colors: a2Colors,
    sidebarWidth: 'w-60',
  },

  R2: {
    name: 'keilog-r2',
    displayName: 'KEiLOG R2',
    logoPath: '/images/keilog/keilog_text.png',
    colors: r2Colors,
    sidebarWidth: 'w-60',
  },

  serviceSelector: {
    backgroundColor: KEILOG_BRAND.surface,
    buttonActiveOpacity: 'CC',
    buttonInactiveOpacity: '80',
  },
};
